/***************************************************************************************************
 * Load `$localize` onto the global scope - used if i18n tags appear in Angular templates.
 */
import '@angular/localize/init';
/**
 * This file includes polyfills needed by Angular and is loaded before the app.
 * You can add your own extra polyfills to this file.
 *
 * This file is divided into 2 sections:
 * 1. Browser polyfills. These are applied before loading ZoneJS and are sorted by browsers.
 * 2. Application imports. Files imported after ZoneJS that should be loaded before your main file.
 *
 * The current setup is for so-called "evergreen" browsers; the last versions of browsers that
 * automatically update themselves. This includes recent versions of Safari, Chrome (including
 * Opera), Edge on the desktop, and iOS and Chrome on mobile.
 *
 * Learn more in https://angular.io/guide/browser-support
 */
/***************************************************************************************************
 * BROWSER POLYFILLS
 */
/**
 * By default, zone.js will patch all possible macroTask and DomEvents
 * user can disable parts of macroTask/DomEvents patch by setting following flags
 * because those flags need to be set before `zone.js` being loaded, and the bundler
 * will put import in the top of bundle, so user need to create a separate file
 * in this directory (for example: zone-flags.ts), and put the following flags
 * into that file, and then add the following code before importing zone.js.
 * import './zone-flags';
 *
 * The flags allowed in zone-flags.ts are listed here.
 *
 * The following flags will work for all browsers.
 *
 * (window as any).__Zone_disable_requestAnimationFrame = true; // disable patch requestAnimationFrame
 * (window as any).__Zone_disable_on_property = true; // disable patch onProperty such as onclick
 * (window as any).__zone_symbol__UNPATCHED_EVENTS = ['scroll', 'mousemove']; // disable patch specified eventNames
 *
 * in IE/Edge developer tools, the addEventListener will also be wrapped by zone.js
 * with the following flag, it will bypass `zone.js` patch for IE/Edge
 *
 * (window as any).__Zone_enable_cross_context_check = true;
 *
 */
import './zone-flags';

/***************************************************************************************************
 * Zone JS is required by default for Angular itself.
 */
import 'zone.js'; // Included with Angular CLI.
// eslint-disable-next-line unicorn/prefer-node-protocol
import { Buffer } from 'buffer';

/**
 * Workaround for Web3 higher than v1.3.0
 * Previously Web3 library contained a 'patch.js' file that monkey-patched the angular-cli 'browser.js'
 * to change `node: false` by `node: {crypto: true, stream: true}`.
 * See https://github.com/ChainSafe/web3.js/pull/2262
 *
 * However, this patch was removed in Web3 v1.3.1 due to some unwanted side effects. So they only suggest to do
 * the same monkey-patching manually yourself :S.
 * See:
 * https://github.com/ChainSafe/web3.js/issues/3717
 * https://github.com/ChainSafe/web3.js/blob/v1.3.1/README.md#web3-and-angular
 *
 * In any case, such patch no longer works as expected in Angular 12 and Webpack 5.
 * See:
 * https://github.com/ChainSafe/web3.js/issues/4090
 * https://github.com/ChainSafe/web3.js/issues/4070
 *
 * So the final solution for this issue that works for Angular 9 and beyond is this one below along with the changes in the tsconfig.json.
 * See:
 * https://github.com/ChainSafe/web3.js/issues/4070#issuecomment-843193781
 * https://github.com/ChainSafe/web3.js/issues/4070#issuecomment-850812474
 */
/* eslint-disable @typescript-eslint/no-explicit-any */
(window as any).global = window;
global.Buffer = Buffer;
global.process = {
  env: { DEBUG: undefined },
  version: '',
} as any;
/* eslint-enable @typescript-eslint/no-explicit-any */
